export const CoreCommands = {
  
  CONNECTION: "connect",
  RECONNECTION: "reconnect",
  DISCONNECT: "disconnect",
  
  CONNECT_ERROR: "connection_error",
  ACTION_ERROR: "action_error",
  
  JOIN_COMPANY: "join_company",
  JOIN_WORKSPACE: "join_workspace",
  JOIN_WORKSPACE_PROJECTS: "join_workspace_projects",
  LEAVE_WORKSPACE_PROJECTS: "leave_workspace_projects",
  JOIN_PROJECT: "join_project",
  CLOSE_PROJECT: "close_project",
  JOIN_TEMPLATE: "join_template",
  CLOSE_TEMPLATE: "close_template",
  JOIN_PROPOSAL: "join_proposal",
  CLOSE_PROPOSAL: "close_proposal",
  
  WORKTYPE_ADD: "wt_add",
  WORKTYPE_EDIT: "wt_change",
  WORKTYPE_REMOVE: "wt_remove",
  
  LABEL_REMOVE: "label_remove",
  LABEL_UPDATE: "label_update",
  LABEL_CREATE: "label_create",
  
  NOTIFICATION: "notification",
  ALERT: "alert",
  
  LOGOUT: "logout",
  
  PROPOSAL_SESSION_START: "proposalSessionStart",
}

export const ProjectCommands = {
  PROJECT_CREATE: "project_create",
  PROJECT_WAS_CREATED: "project_was_created",
  PROJECT_PROGRESS: "project_creation_progress",
  PROJECT_RENAME: "project_rename",
  PROJECT_STATUS: "project_status",
  PROJECT_REMOVE: "project_remove",
  PROJECT_ARCHIVE: "project_archive",
  PROJECT_METADATA: "project_metadata",
  
  USER_ADD: "user_add",
  USER_REMOVE: "user_remove",
  USER_PROMOTE: "user_promote",
}

export const TemplateCommands = {
  TEMPLATE_PROGRESS: "template_open_progress",
  
  TEMPLATE_REMOVE: "template_remove",
  TEMPLATE_RENAME: "template_rename",
  
  TEMPLATE_METADATA: "template_metadata"
}

export const ProjectEditorCommands = {
  
  USER_JOINED: "project_user_joined",
  USER_LEFT: "project_user_left",
  USER_MOVE: "project_user_move",
  
  PATCH: "project_patch",
  COMMENT_PATCH: "project_comment_patch",
  
  COMMENT_ADD: "project_comment_add",
  COMMENT_EDIT: "project_comment_update",
  COMMENT_REMOVE: "project_comment_remove",
  COMMENT_REMOVE_PATH: "project_comment_path_remove",
  COMMENT_MOVE: "project_comment_move",
  COMMENT_ELEMENT_RENAME: "project_comment_element_rename",
  
  VERSION_REQUEST: "project_version_get",
  VERSION_NEW: "project_version_add",
  VERSION_IMPORT: "project_version_import",
  VERSION_REMOVE: "project_version_remove",
  VERSION_RENAME: "project_version_rename",
  VERSION_ORDER: "project_version_order",
  VERSION_VISIBILITY: "project_version_visibility",
  VERSION_LOCK: "project_version_locked",
  VERSION_LIST: "project_version_list",
  
  VERSIONS_WORK_TYPE_UPDATE: "project_versions_wt_update",
  
  PERMIT_ADD: "permit_add",
  PERMIT_REMOVE: "permit_remove",
  PERMIT_STATUS: "permit_update",
  PERMIT_USER_VISIBILITY: "user_permit_update",
  
  COVER_ADD: "cover_add",
  COVER_REMOVE: "cover_remove",
  COVER_PAGES: "cover_update_pages",
  COVER_SCALE: "cover_update_scale",
  
  SHARE_SETTINGS: "shareSettings",
  
  GENERATOR_START: "project_generated_start",
  GENERATOR_PART: "project_generated_part",
  GENERATOR_REASONING: "project_generated_reasoning",
  GENERATOR_END: "project_generator_end",
  GENERATOR_STOP: "project_generator_stop",
  
  LABEL_REMOVE: "project_label_remove",
  LABEL_CREATE: "project_label_create",
  
  AGENT_SESSION_START: "project_agent_session_start",
  AGENT_SESSION_END: "project_agent_session_end",
  AGENT_SESSION_TAKEOVER: "project_agent_session_takeover",
}

export const TemplateEditorCommands = {
  USER_JOINED: "template_user_joined",
  USER_LEFT: "template_user_left",
  USER_MOVE: "template_user_move",
  
  PATCH: "template_patch",
  
  VERSION_REQUEST: "template_version_get",
  VERSION_NEW: "template_version_add",
  VERSION_IMPORT: "template_version_import",
  VERSION_REMOVE: "template_version_remove",
  VERSION_RENAME: "template_version_rename",
  VERSION_ORDER: "template_version_order",
  VERSION_VISIBILITY: "template_version_visibility",
  VERSION_LOCK: "template_version_locked",
  VERSION_LIST: "template_version_list",
  
  VERSIONS_WORK_TYPE_UPDATE: "template_versions_wt_update",
  
  LABEL_CREATE: "template_label_create",
  LABEL_REMOVE: "template_label_remove",
}


export const TemplateCommentCommands = {
  COMMENT_PATCH: "template_comment_patch",
  
  COMMENT_ADD: "template_comment_add",
  COMMENT_EDIT: "template_comment_update",
  COMMENT_REMOVE: "template_comment_remove",
  COMMENT_REMOVE_PATH: "template_comment_path_remove",
  COMMENT_MOVE: "template_comment_move",
  COMMENT_ELEMENT_RENAME: "template_comment_element_rename",
}